import Logo from './Logo';
import { companyInfo, navLinks } from '../data/siteData';

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-nosta-espresso text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-5">
            <Logo inverted className="h-16 w-auto mb-6" />
            <p className="text-white/50 leading-relaxed max-w-sm">
              Kaliteli yaşam alanları inşa ederek geleceğe değer katıyoruz.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="eyebrow mb-5">Menü</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.section}>
                  <button
                    onClick={() => onNavigate(link.section)}
                    className="text-white/60 hover:text-nosta-goldSoft transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="eyebrow mb-5">Ofis</h3>
            <ul className="space-y-3 text-white/60 text-sm leading-relaxed">
              <li>{companyInfo.phone}</li>
              <li>{companyInfo.email}</li>
              <li>{companyInfo.address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs tracking-wide text-white/35 uppercase">
          <p>
            © {new Date().getFullYear()} {companyInfo.name}
          </p>
          <p>Enez · Bayramoğlu · Esenyurt</p>
        </div>
      </div>
    </footer>
  );
}
